import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';
import { SearchType } from '../../../../api/enums';

export const useMoveToSearchResult = () => {
  const navigation = useRootStackNavigation();

  return useCallback<
    (params: {
      keyword: string;
      searchType: SearchType;
      delivery_type?: string;
      from_screen?: string;
    }) => void
  >(
    params => {
      const { keyword, searchType } = params;

      // if (isWeb) {
      navigation.push('SearchResult', {
        query: keyword,
        search_type: searchType,
        ...(params.delivery_type === 'fast' && {
          delivery_type: params.delivery_type,
        }),
        ...(params.from_screen && { from_screen: params.from_screen }),
      });
      // return;
      // }
      // const extras = JSON.stringify({
      //   query: keyword,
      //   search_type: searchType,
      //   from_instance_id: instanceId,
      //   // fast 타입일 때만 포함 → FilterListAtom → API 자동 전달
      //   ...(params.delivery_type === 'fast' && {
      //     delivery_type: params.delivery_type,
      //   }),
      //   // 로깅 준비용 (API 미전달, params에만 보관)
      //   ...(params.from_screen && { from_screen: params.from_screen }),
      // });
      // const encodedExtras = encodeURIComponent(extras);
      // const deeplink = `ably://react/App?screen=SearchResult&extras=${encodedExtras}`;
      // openDeeplink(deeplink);
    },
    [navigation],
  );
};
